module.exports = __webpack_public_path__ + "static/media/pol.5746b05f.svg";